/*
 * File: SalesOrderStatus.ts
 * Project: papa-bear
 * -----
 * Last Modified: 14 Jan 2022 12:58:11 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

export enum SalesOrderStatus {
  DRAFT = 'Draft',
  POSTED = 'Posted'
}
